import { render, staticRenderFns } from "./signatureInput.vue?vue&type=template&id=4c0973cc&scoped=true&"
import script from "./signatureInput.vue?vue&type=script&lang=ts&"
export * from "./signatureInput.vue?vue&type=script&lang=ts&"
import style0 from "./signatureInput.vue?vue&type=style&index=0&id=4c0973cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0973cc",
  null
  
)

export default component.exports